/**
 * @generated SignedSource<<78147b31be625e0f27e1cd662bee3f70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type customizerTestOrderMutation$variables = {
  compositionDocID?: string | null;
  designDocID?: string | null;
};
export type customizerTestOrderMutation$data = {
  readonly createTestOrder: {
    readonly orderID: number;
  };
};
export type customizerTestOrderMutation = {
  response: customizerTestOrderMutation$data;
  variables: customizerTestOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compositionDocID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "designDocID"
},
v2 = [
  {
    "kind": "Variable",
    "name": "compositionDocID",
    "variableName": "compositionDocID"
  },
  {
    "kind": "Variable",
    "name": "designDocID",
    "variableName": "designDocID"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "customizerTestOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "customizerTestOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd7904c1ca1c372967ddd19b8ef9282e",
    "id": null,
    "metadata": {},
    "name": "customizerTestOrderMutation",
    "operationKind": "mutation",
    "text": "mutation customizerTestOrderMutation(\n  $designDocID: String\n  $compositionDocID: String\n) {\n  createTestOrder(designDocID: $designDocID, compositionDocID: $compositionDocID) {\n    orderID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "589df57e785c85538cd645f81c8d793d";

export default node;
